module.exports = __webpack_public_path__ + "static/media/dsr_finance4.0b3a86e5.svg";